import { Component, OnInit } from '@angular/core';

import { NgxUiLoaderService } from 'ngx-ui-loader';

import { Globals } from '../../_models/globals';

import { NotificationService } from '../../_services/notification.service';
import { RepairerManagerCashbackService } from './cashback.service';
import { ApiResponseModel } from 'app/_models/apiResponseModel';
import { RepairerManagerCashbackGetAllResponseModel } from '../_models/repairerManagerCashbackGetAllResponseModel';
import { SweetAlertParams } from 'app/_models/notificationParams.model';
import { CashbackStatusEnum } from '../_models/_enums/cashbackStatus.enum';

declare const compararStringContemString: any;
declare const getJavascriptDateFromFormattedDate: any;
declare const isEmpty: any;
declare const obterNomeMesAno: any;
declare const numberToReal: any;
declare const replaceAll: any;
declare const sort_by: any;

@Component({
    selector: 'app-cashback', templateUrl: './cashback.component.html', styleUrls: ['./cashback.component.scss'],
    standalone: false
})
export class RepairerManagerCashbackComponent implements OnInit
{
    _searchTerm: string;

    in_log_view: boolean;
    periodo_id_selecionado: string;
    status_id_selecionado: string;
    hideFutureCashback: boolean;

    Swal: any;

    transacoes: any;
    transacoesFiltradas: any;

    prazo_pagamento: number;
    total_custo_retirada: number;
    total_disponivel: number;
    total_pendente: number;
    total_resgatado: number;
    total_resgate_solicitado: number;
    total_valor_minimo_retirada: number;

    get CashbackStatusEnum(): typeof CashbackStatusEnum {
        return CashbackStatusEnum;
    }

    constructor(private notificationService: NotificationService, private cashbackService: RepairerManagerCashbackService, private globals: Globals, private ngxLoader: NgxUiLoaderService) {
        this.in_log_view = true;
        this.searchTerm = '';
        this.periodo_id_selecionado = "30";
        this.status_id_selecionado = "0";
        this.hideFutureCashback = false;

        this.transacoes = [];
        this.transacoesFiltradas = [];

        this.prazo_pagamento = 0;
        this.total_custo_retirada = 0;
        this.total_disponivel = 0;
        this.total_pendente = 0;
        this.total_resgatado = 0;
        this.total_resgate_solicitado = 0;
        this.total_valor_minimo_retirada = 0;
    }

    ngOnInit() {
        this.Swal = require('sweetalert2');
        this.carregarTela(0);
    }

    atualizarTransacoesFiltradas() {
        this.transacoesFiltradas = this.filtrarTransacoes();
        this.sortTransacoes();
    }

    carregarTela(nAttempts:number) {
        this.ngxLoader.startLoader('loader-principal');

        this.cashbackService.getAll().subscribe({
            next: (response: ApiResponseModel<RepairerManagerCashbackGetAllResponseModel>) => {
                if (response != null) {
                    this.transacoes = response.result.transacoes;

                    this.transacoes.map(t => {
                        t.creation_date_js = getJavascriptDateFromFormattedDate(t.creation_date_formatada);
                        t.release_date_js = getJavascriptDateFromFormattedDate(t.release_date_formatada);

                        const statusClasses = {
                            [CashbackStatusEnum.PedidoCancelado]: 'bg-gray',
                            [CashbackStatusEnum.PendenteLiberacao]: 'bg-warning',
                            [CashbackStatusEnum.Disponivel]: 'bg-success',
                            [CashbackStatusEnum.PendenteResgate]: 'bg-primary-dark',
                            [CashbackStatusEnum.Resgatado]: 'bg-primary',
                        };

                        t.status_class = statusClasses[t.status_id];
                        t.order_date_js = t.status_id != CashbackStatusEnum.PendenteResgate ? t.release_date_js : t.creation_date_js;

                        if (t.release_date_js) {
                            t.release_date_mes_referencia = obterNomeMesAno(t.release_date_js.getFullYear() + '' + (t.release_date_js.getMonth() + 1));
                        }
                    });

                    this.total_disponivel = response.result.totalDisponivel;
                    this.total_pendente = response.result.totalPendente;
                    this.total_resgatado = response.result.totalResgatado;
                    this.total_resgate_solicitado = response.result.totalResgateSolicitado;

                    this.total_custo_retirada = response.result.custoRetirada;
                    this.prazo_pagamento = response.result.prazoPagamento;
                    this.total_valor_minimo_retirada = response.result.valorMinimoRetirada;

                    this.atualizarTransacoesFiltradas();
                }

                this.ngxLoader.stopLoader('loader-principal');
            },
            error: error => {
                nAttempts = nAttempts || 1;
                console.log(error, nAttempts);

                if (nAttempts >= 5)
                {
                    this.ngxLoader.stopLoader('loader-principal');
                    this.notificationService.showErrorToastr(this.globals.translate('repairer-manager.cashback.mensagens.erro.carregamento.corpo'));
                    return;
                }

                this.carregarTela(++nAttempts);
            }
        });
    }

    filtrarTransacoes() {
        if (isEmpty(this.transacoes))
            return this.transacoes;

        let today = new Date(new Date().setHours(21, 0, 0, 0));
        let periodoCorte = new Date().setDate(today.getDate() - parseInt(this.periodo_id_selecionado));

        let status_id = parseInt(this.status_id_selecionado);

        let filtered = this.transacoes.filter(el => (status_id === 0 || (el.status_id === status_id && !el.already_paid) || (status_id === 4 && el.already_paid)) && (el.release_date_js > periodoCorte || !el.release_date_js) && (!this.hideFutureCashback || el.order_date_js <= today));

        if (isEmpty(this.searchTerm))
            return filtered;

        var term: string = replaceAll(this.searchTerm.toLowerCase() , '-', '');

        return filtered.filter(quotation => {
                const vehicle = quotation.veiculo.toLowerCase();
                const licensePlate = vehicle.substring(vehicle.lastIndexOf('(') + 1, vehicle.lastIndexOf(')')).replace(' ', '').replace('-', '');

                return quotation.order_id != null &&
                      (quotation.order_id.toString().indexOf(term) !== -1 ||
                       compararStringContemString(quotation.brand_name, term) ||
                       compararStringContemString(quotation.fornecedor, term) ||
                      (!isEmpty(quotation.veiculo) && (compararStringContemString(vehicle, term) || compararStringContemString(licensePlate, replaceAll(term, ' ', '')))))
            });
    }

    limpar() {
        this.periodo_id_selecionado = "30";
        this.status_id_selecionado = "0";
        this.searchTerm = "";
        this.hideFutureCashback = false;

        this.atualizarTransacoesFiltradas();
    }

    solicitarResgate() {
        let cashback_solicitado = this.total_disponivel;
        let valor_receber = cashback_solicitado - this.total_custo_retirada;
        let custo_retirada = this.total_custo_retirada > 0 ? `- ${numberToReal(this.total_custo_retirada)}` : numberToReal(this.total_custo_retirada);

        let params: SweetAlertParams = {
            title: 'repairer-manager.cashback.solicitar-resgate.titulo',
            message:
                '<ul class="cashback">' +
                '<li>' + this.globals.translate('repairer-manager.cashback.solicitar-resgate.valor-solicitado') + ' <span>' + numberToReal(cashback_solicitado) + '</span></li>' +
                '<li class="text-danger">' + this.globals.translate('repairer-manager.cashback.solicitar-resgate.custo-retirada') + ' <span>' + custo_retirada + '</span></li>' +
                '<li>' + this.globals.translate('repairer-manager.cashback.solicitar-resgate.valor-receber') + ' <span><b>' + numberToReal(valor_receber) + '</b></span></li>' +
                '<li class="text-center">' + this.globals.translate('repairer-manager.cashback.solicitar-resgate.prazo-pagamento.parte-1') + ' <b>' + this.prazo_pagamento + '</b> ' + this.globals.translate('repairer-manager.cashback.solicitar-resgate.prazo-pagamento.parte-2') + '</li>' +
                '</ul>',
            icon: 'warning',
            isHtml: true
        }

        this.notificationService.showConfirm(params).then((result) => {
            if (result.value) {
                this.ngxLoader.startLoader('loader-principal');
                this.cashbackService.requestWithdraw().subscribe({
                    next: (response: ApiResponseModel<boolean>) => {
                        if (response != null) {
                            this.notificationService.showSuccessToastr(this.globals.translate('repairer-manager.cashback.mensagens.sucesso.solicitar-resgate.corpo'));
                            this.carregarTela(0);
                        }

                        this.ngxLoader.stopLoader('loader-principal');
                    },
                    error: error => {
                        console.log(error);
                        this.notificationService.showErrorToastr(this.globals.translate('repairer-manager.cashback.mensagens.erro.solicitar-resgate.corpo'));
                        this.ngxLoader.stopLoader('loader-principal');
                    }
                });
            }
        });
    }

    sortTransacoes() {
        if (isEmpty(this.transacoesFiltradas))
            return;

        this.transacoesFiltradas.sort(sort_by([{ name: 'order_date_js', reverse: true }]));
    }

    verHistorico() {
        this.limpar();
        this.in_log_view = !this.in_log_view;
    }


    get searchTerm(): string {
        return this._searchTerm;
    }

    set searchTerm(value: string) {
        this._searchTerm = value;
        this.atualizarTransacoesFiltradas();
    }
}
